import { render, staticRenderFns } from "./zhiboclassxq.vue?vue&type=template&id=0f07329a&scoped=true"
import script from "./zhiboclassxq.vue?vue&type=script&lang=js"
export * from "./zhiboclassxq.vue?vue&type=script&lang=js"
import style0 from "./zhiboclassxq.vue?vue&type=style&index=0&id=0f07329a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07329a",
  null
  
)

export default component.exports